import React from 'react';
import type { ChannelIntegrationEditorProps } from 'components/integrations/ChannelIntegrationEditor/ChannelIntegrationEditorProps';
import type { IntegrationPropertyType } from 'application-types';
import { FloorMapping } from './FloorMapping';

type FloorOption = { label: string; value: string; isDisabled?: boolean };

type KastleFloorMappingProps = {
  property: IntegrationPropertyType;
  value?: any;
  label?: string;
  onChange: (value: any) => void;
  channel: ChannelIntegrationEditorProps['channel'];
  settings: ChannelIntegrationEditorProps['channelIntegration']['settings'];
  metadataLoading?: boolean;
  // Explicit list of Kastle floor options. When provided this takes precedence
  // over property.acsFloorId, which is a shared singleton on
  // AccessControlServiceDefinitions and does not reliably trigger re-renders.
  providerFloorOptions?: FloorOption[];
};

export const KastleFloorMapping = ({
  property,
  value,
  label,
  onChange,
  channel,
  settings,
  metadataLoading,
  providerFloorOptions,
}: KastleFloorMappingProps) => {
  const floorOptions =
    providerFloorOptions ?? (property?.acsFloorId as FloorOption[] | undefined) ?? [];

  return (
    <FloorMapping
      property={property}
      value={value}
      label={label}
      onChange={onChange}
      channel={channel}
      settings={settings}
      metadataLoading={metadataLoading}
      floorKey="acsFloorId"
      sourceDisplayName="Activate"
      providerDisplayName="Kastle"
      providerFloorOptions={floorOptions}
    />
  );
};